module.exports = __webpack_public_path__ + "img/defect-002.198765d8.png";